import { forwardRef as L, useState as I, Fragment as T, useRef as v, useEffect as F } from "react";
import D from "../../node_modules/classnames/index.js";
import x from "../../node_modules/lodash/clamp.js";
import l from "../../node_modules/lodash/mapValues.js";
import "./UIInputDate2.js";
import { jsx as h, jsxs as _ } from "../../_virtual/jsx-runtime.js";
import $ from "../../node_modules/date-fns/esm/isValid/index.js";
import R from "../../node_modules/date-fns/esm/getDate/index.js";
import Y from "../../node_modules/date-fns/esm/getMonth/index.js";
import A from "../../node_modules/date-fns/esm/getYear/index.js";
const y = ["day", "month", "year"];
function U(t, e, n = "0") {
  return Array(e - String(t).length + 1).join(n) + t;
}
function C(t) {
  return !t || t.toString().length < 4 || t % 4 === 0 && t % 100 || t % 400 === 0 ? 29 : 28;
}
function M(t, e) {
  switch (t) {
    case 2:
      return C(e);
    case 9:
    case 4:
    case 6:
    case 11:
      return 30;
    default:
      return 31;
  }
}
function j(t, e, n) {
  if (t === void 0 || e === void 0 || n === void 0)
    return !1;
  const o = new Date(n, e - 1, t);
  return e >= 1 && e < 13 && t > 0 && t <= M(e, n) && $(o) && n.toString().length === 4;
}
const E = {
  day: "JJ",
  month: "MM",
  year: "AAAA"
}, O = {
  day: 2,
  month: 2,
  year: 4
};
function S() {
  return {
    day: v(null),
    month: v(null),
    year: v(null)
  };
}
function N(t) {
  return t ? {
    day: R(t),
    month: Y(t) + 1,
    year: A(t)
  } : {
    day: void 0,
    month: void 0,
    year: void 0
  };
}
function J(t, e, n) {
  F(() => {
    const o = l(e, (r) => r === void 0 ? void 0 : parseInt(r, 10));
    if (j(o.day, o.month, o.year)) {
      const r = new Date(o.year, o.month - 1, o.day);
      (n == null ? void 0 : n.getTime()) !== r.getTime() && t(new Date(r));
    } else
      n != null && t(null);
  }, [e]);
}
function P(t, e, n) {
  F(() => {
    (n == null ? void 0 : n.getTime()) !== (t == null ? void 0 : t.getTime()) && e(l(N(t), (o) => o == null ? void 0 : o.toString()));
  }, [t]);
}
function V(t, e) {
  const n = N(t), [o, r] = I(t), [i, a] = I(l(n, (s) => s == null ? void 0 : s.toString())), u = (s) => {
    !e || (r(s ? new Date(s) : null), e(s ? new Date(s) : null));
  };
  return P(t, a, o), J(u, i, o), [i, a];
}
const k = (t, e, n, o) => {
  var f;
  const r = y.indexOf(n), i = y[r + 1], a = l(e, (d) => d === void 0 ? void 0 : parseInt(d, 10)), u = a.month ? M(a.month, a.year) : 31;
  return i && (n === "day" && (o.value.length >= o.maxLength || parseInt(`${a.day}1`, 10) > u) || n === "month" && (o.value.length >= o.maxLength || parseInt(`${a.month}1`, 10) > 12) || n === "year" && ((f = a.year) == null ? void 0 : f.toString().length) === 4) ? t[i].current : null;
};
function B(t) {
  const e = l(t, (o) => o === void 0 ? void 0 : parseInt(o, 10)), n = e.month ? M(e.month, e.year) : 31;
  return {
    day: e.day === void 0 ? void 0 : x(e.day, 0, n),
    month: e.month === void 0 ? void 0 : x(e.month, 0, 12),
    year: e.year === void 0 ? void 0 : x(e.year, 0, 9999)
  };
}
const G = (t, e, n, o) => (r) => {
  var p;
  const i = parseInt(r.target.value, 10), a = r.target.value.length, u = i >= 0 ? i : void 0;
  if (!u && a === r.target.maxLength) {
    r.preventDefault(), r.stopPropagation();
    return;
  }
  const s = {
    ...e,
    [o]: u
  }, f = B(s), d = l(f, (m, c) => {
    if (m !== void 0)
      return c === o ? U(m, a) : m.toString().padStart(2, "0");
  }), g = k(t, d, o, r.target);
  g && (d[o] = (p = d[o]) == null ? void 0 : p.padStart(2, "0")), n(d), g && g.focus();
}, q = (t, e) => (n) => {
  const {
    currentTarget: o
  } = n;
  setTimeout(() => {
    o.contains(document.activeElement) || (t && t(n), e(!1));
  }, 0), n.stopPropagation(), n.preventDefault();
}, z = (t) => (e) => {
  e.target.select(), t(!0);
}, H = (t) => (e) => {
  t && e.target === e.currentTarget && e.preventDefault();
}, K = (t) => (e) => {
  var n;
  e.target === e.currentTarget && ((n = t.day.current) == null || n.focus());
}, at = L(({
  name: t,
  value: e,
  onChange: n,
  onBlur: o,
  hasError: r,
  className: i,
  variant: a = "medium",
  disabled: u
}, s) => {
  const f = S(), [d, g] = V(e, n), [p, m] = I(!1);
  return /* @__PURE__ */ h("div", {
    className: D("input-date", {
      "input-date--large": a === "large",
      "input-date--medium": a === "medium"
    }, i),
    children: /* @__PURE__ */ h("div", {
      "data-disabled": u,
      className: D("input-date__inner", "shakeable"),
      onBlur: q(o, m),
      "data-error": r ? "true" : "false",
      tabIndex: -1,
      onMouseDown: H(p),
      onFocus: K(f),
      ref: s,
      children: y.map((c, w) => /* @__PURE__ */ _(T, {
        children: [/* @__PURE__ */ h("input", {
          disabled: u,
          name: `${t}-${c}`,
          type: "text",
          inputMode: "numeric",
          placeholder: E[c],
          maxLength: O[c],
          value: d[c] || "",
          onChange: G(f, d, g, c),
          onFocus: z(m),
          className: D("input-date__value", `input-date__${c}`),
          id: `inputDate-${t}-${c}`,
          ref: f[c]
        }), w < y.length - 1 && /* @__PURE__ */ h("span", {
          className: "input-date__separator"
        })]
      }, c))
    })
  });
});
export {
  at as UIInputDate,
  M as daysInMonth,
  B as getCappedUnits,
  j as isValid,
  U as padLeft
};
//# sourceMappingURL=UIInputDate.js.map
